import * as yup from 'yup';

function emptyToNull() {
    return this.transform((value, original) => {
        return original === "" ? null : value
    }).nullable()
}

yup.addMethod(yup.string, 'emptyToNull', emptyToNull);
yup.addMethod(yup.number, 'emptyToNull', emptyToNull);

export { yup };